import { currentBackend } from '../backend';
import { addNotification, clearNotifications } from './notifications';
import { refilterConfigForPermissions } from './config';
import { stopDeployNotifications } from './deployStatus';
// Any backend's resolved user may carry `permissions`; the field name stays
// backend-neutral, and core re-filters the loaded config against it.
function dispatchPermissionsRefilterIfPresent(dispatch, user) {
  const permissions = user.permissions;
  if (permissions) {
    dispatch(refilterConfigForPermissions(permissions));
  }
}
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_REQUEST_DONE = 'AUTH_REQUEST_DONE';
export const USE_OPEN_AUTHORING = 'USE_OPEN_AUTHORING';
export const LOGOUT = 'LOGOUT';
export function authenticating() {
  return {
    type: AUTH_REQUEST
  };
}
export function authenticate(userData) {
  return {
    type: AUTH_SUCCESS,
    payload: userData
  };
}
export function authError(error) {
  return {
    type: AUTH_FAILURE,
    error: 'Failed to authenticate',
    payload: error
  };
}
export function doneAuthenticating() {
  return {
    type: AUTH_REQUEST_DONE
  };
}
export function useOpenAuthoring() {
  return {
    type: USE_OPEN_AUTHORING
  };
}
export function logout() {
  return {
    type: LOGOUT
  };
}

// Check if user data token is cached and is valid
export function authenticateUser() {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    dispatch(authenticating());
    return Promise.resolve(backend.currentUser()).then(user => {
      if (user) {
        if (user.useOpenAuthoring) {
          dispatch(useOpenAuthoring());
        }
        dispatch(authenticate(user));
        dispatchPermissionsRefilterIfPresent(dispatch, user);
      } else {
        dispatch(doneAuthenticating());
      }
    }).catch(error => {
      dispatch(authError(error));
      dispatch(logoutUser());
    });
  };
}

/** The backend found its session dead mid-use: the same exit as a failed restore. */
export function sessionInvalidated(message) {
  return (dispatch, getState) => {
    if (!getState().auth.user) return;
    dispatch(authError(new Error(message)));
    dispatch(logoutUser());
  };
}
export function loginUser(credentials) {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    dispatch(authenticating());
    return backend.authenticate(credentials).then(user => {
      if (user.useOpenAuthoring) {
        dispatch(useOpenAuthoring());
      }
      dispatch(authenticate(user));
      dispatchPermissionsRefilterIfPresent(dispatch, user);
    }).catch(error => {
      console.error(error);
      dispatch(addNotification({
        message: {
          details: error.message,
          key: 'ui.toast.onFailToAuth'
        },
        type: 'error',
        dismissAfter: 8000
      }));
      dispatch(authError(error));
      dispatch(doneAuthenticating());
    });
  };
}
export function logoutUser() {
  return (dispatch, getState) => {
    const state = getState();
    const backend = currentBackend(state.config);
    // Before backend.logout(): the subscriptions are module singletons, and left
    // set they would skip resubscribing after the next login.
    stopDeployNotifications();
    Promise.resolve(backend.logout()).then(() => {
      dispatch(logout());
      dispatch(clearNotifications());
    });
  };
}